<template>
  <div>
    <el-progress v-if="socket_key" :percentage="progress"></el-progress>
    <div class="search-wrap">
      <el-button size="mini" @click="pageChange(1)">查询</el-button>


      <el-button size="mini" @click="getAllExcel()">综合账单导出</el-button>
    </div>
    <div>
      <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'41%'}">
        <el-descriptions-item label="项目房产">
          {{mainObj.house_name?mainObj.house_name:'请选择项目房产'}}
        </el-descriptions-item>
        <el-descriptions-item label="抄表月份">
          <el-date-picker
            v-model="mainObj.read_month"
            size="mini"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            @change="pageChange(1)"
            placeholder="选择月">
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="客户房产">
          <el-autocomplete
            style="min-width: 400px;max-width: 100%"
            size="mini"
            v-model="mainObj.house_name"
            :fetch-suggestions="querySearchAsyncRoom"
            @select="handleSelect"
            placeholder="请输入房产"
            popper-class="autocomplete-room"
            clearable
          ></el-autocomplete>
        </el-descriptions-item>
        <el-descriptions-item label="应收日期">
          <el-date-picker
            v-model="where.should_charge_date"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            @change="pageChange(1)"
            placeholder="选择日期">
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label-class-name="descriptions-label-class" label="客户名称">
          <el-autocomplete
            class="w-300"
            size="mini"
            v-model="where.customer_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入姓名"
            @select="handleSelect2"
          ></el-autocomplete>
        </el-descriptions-item>

        <el-descriptions-item label="收费项目">
          <el-select size="mini" style="width: 100%" v-model="where2.chargeItem_name_id" filterable clearable placeholder="收费项目" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in house_charge_item_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="收费标准">
          <el-select size="mini" style="width: 100%" v-model="where2.charging_standard" filterable clearable placeholder="收费标准" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in house_charge_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>

        <el-descriptions-item label="能耗类型">
          <el-select size="mini" style="width: 100%" v-model="where.energy" clearable filterable placeholder="类型" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in energy_list" :key="item.val" :label="item.name" :value="item.val"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="是否锁定">
          <el-select size="mini" style="width: 100%" v-model="where.is_lock" clearable filterable placeholder="请选择" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in [{name:'未锁定',val:0},{name:'已锁定',val:1}]" :key="item.val" :label="item.name" :value="item.val"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="是否审核">
          <el-select size="mini" style="width: 100%" v-model="where.is_examine" clearable filterable placeholder="请选择" class="kuan" @change="pageChange(1)">
            <el-option v-for="item in [{name:'未审核',val:0},{name:'待审核',val:1},{name:'已审核',val:2},{name:'已驳回',val:-1}]" :key="item.val" :label="item.name" :value="item.val"></el-option>
          </el-select>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <el-collapse accordion>
      <el-collapse-item name="1">
        <template slot="title">
          <span>
            统计信息
          </span>
        </template>
        <div>
          <div class="header-tip">
            三级表 [成本]： {{formatMoney(meter_order_obj.amount3,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
            分摊损耗 [成本]： {{formatMoney(meter_order_obj.xs_accumulate_amount,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
            固定金额： {{formatMoney(meter_order_obj.fixed_amount3,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
            分摊能耗 [成本]： {{formatMoney(meter_order_obj.allocated_amount,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
            <br>
            四级表 [成本]： {{formatMoney(meter_order_obj.amount4,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
            <!--      物业能耗 [成本]： {{formatMoney(order_count_obj.allocated_amount4,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;-->
            {{user_type==1?'业主':'物业'}}损耗 [成本]： {{formatMoney(meter_order_obj.xs_accumulate_amount4,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
            固定金额： {{formatMoney(meter_order_obj.fixed_amount4,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
            {{user_type==1?'业主':'物业'}}能耗 [销售]： {{formatMoney(meter_order_obj.total_sales_amount,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
            <br>
            总计收费 【分摊能耗 [成本] + {{user_type==1?'业主':'物业'}}能耗 [销售]】： {{formatMoney(meter_order_obj.all_amount,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
          </div>
          <div class="header-tip">
            总计收费 【分摊能耗 [成本] + {{user_type==1?'业主':'物业'}}能耗 [销售]】： {{formatMoney(meter_order_object_obj.all_amount,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
            分摊能耗 [成本]： {{formatMoney(meter_order_object_obj.allocated_amount,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
            {{user_type==1?'业主':'物业'}}能耗 [销售]： {{formatMoney(meter_order_object_obj.total_sales_amount,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
          </div>
          <div class="header-tip">
            总计收费： {{formatMoney(meter_order_house_obj.all_money,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            业主能耗： {{formatMoney(meter_order_house_obj.money_1,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            分摊能耗 [成本价]： {{formatMoney(meter_order_house_obj.money_3,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            物业能耗 [销售价]： {{formatMoney(meter_order_house_obj.money_2,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>

    <h3>费用组成</h3>
    <div class="meter-order-table-wrap">
      <table class="meter-order-table" cellspacing="0" cellpadding="0" border="0" width="100%">
        <thead>
          <tr>
            <th style="width: 100px">能耗类型</th>
            <th>仪表等级</th>
            <th>损耗累计</th>
            <th>固定金额</th>
            <th>用量计费</th>
            <th>分摊计费</th>
            <th>用户计费</th>
          </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{user_type==1?'业主':'物业'}}能耗</td>
          <td>{{formatMoney(meter_order_obj.amount4,4)}}<br/>[四级表销售价]</td>
          <td>{{formatMoney(meter_order_obj.xs_accumulate_amount4,4)}}<br/>[成本价]</td>
          <td>{{formatMoney(meter_order_obj.fixed_amount4,4)}}</td>
          <td>{{formatMoney(meter_order_obj.total_sales_amount,4)}}<br/>[销售价]</td>
          <td>{{formatMoney(meter_order_object_obj.total_sales_amount,4)}}<br/>[销售价]</td>
          <td>{{formatMoney(meter_order_house_obj.money_2,4)}}<br/>[销售价]</td>
        </tr>
        <tr>
          <td>分摊能耗</td>
          <td>{{formatMoney(meter_order_obj.amount3,4)}}<br/>[三级表成本价]</td>
          <td>{{formatMoney(meter_order_obj.xs_accumulate_amount,4)}}<br/>[成本价]</td>
          <td>{{formatMoney(meter_order_obj.fixed_amount3,4)}}</td>
          <td>{{formatMoney(meter_order_obj.allocated_amount,4)}}<br/>[成本价]</td>
          <td>{{formatMoney(meter_order_object_obj.allocated_amount,4)}}<br/>[成本价]</td>
          <td>{{formatMoney(meter_order_house_obj.money_3,4)}}<br/>[成本价]</td>
        </tr>
        </tbody>
      </table>
    </div>

    <h3>每个阶段计算对比</h3>
    <div class="meter-order-table-wrap">
      <table class="meter-order-table" cellspacing="0" cellpadding="0" border="0" width="100%">
        <thead>
        <tr>
          <th style="width: 100px">费用类型</th>
          <th style="width: 180px">用量计费</th>
          <th>分摊计费</th>
          <th>用户计费</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{user_type==1?'业主':'物业'}}能耗</td>
          <td>{{formatMoney(meter_order_obj.total_sales_amount,4)}}</td>
          <td>
            {{formatMoney(meter_order_object_obj.total_sales_amount,4)}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span title="和用量计费对比">{{reNumber(meter_order_object_obj.total_sales_amount-meter_order_obj.total_sales_amount)}}</span>
            <i class="el-icon-top" style="color: #ff0000" v-if="unusualChange(meter_order_object_obj.total_sales_amount,meter_order_obj.total_sales_amount)===1"></i>
            <i class="el-icon-bottom" style="color: #ff6200" v-if="unusualChange(meter_order_object_obj.total_sales_amount,meter_order_obj.total_sales_amount)===-1"></i>
          </td>
          <td>
            {{formatMoney(meter_order_house_obj.money_2,4)}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span title="和用量计费对比">{{reNumber(meter_order_house_obj.money_2-meter_order_obj.total_sales_amount)}}</span>
            <i class="el-icon-top" style="color: #ff0000" v-if="unusualChange(meter_order_house_obj.money_2,meter_order_obj.total_sales_amount)===1"></i>
            <i class="el-icon-bottom" style="color: #ff6200" v-if="unusualChange(meter_order_house_obj.money_2,meter_order_obj.total_sales_amount)===-1"></i>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span title="和分摊计费对比">{{reNumber(meter_order_house_obj.money_2-meter_order_object_obj.total_sales_amount)}}</span>
            <i class="el-icon-top" style="color: #ff0000" v-if="unusualChange(meter_order_house_obj.money_2,meter_order_object_obj.total_sales_amount)===1"></i>
            <i class="el-icon-bottom" style="color: #ff6200" v-if="unusualChange(meter_order_house_obj.money_2,meter_order_object_obj.total_sales_amount)===-1"></i>
          </td>
        </tr>
        <tr>
          <td>分摊能耗</td>
          <td>{{formatMoney(meter_order_obj.allocated_amount,4)}}</td>
          <td>
            {{formatMoney(meter_order_object_obj.allocated_amount,4)}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span title="和用量计费对比">{{reNumber(meter_order_object_obj.allocated_amount-meter_order_obj.allocated_amount)}}</span>
            <i class="el-icon-top" style="color: #ff0000" v-if="unusualChange(meter_order_object_obj.allocated_amount,meter_order_obj.allocated_amount)===1"></i>
            <i class="el-icon-bottom" style="color: #ff6200" v-if="unusualChange(meter_order_object_obj.allocated_amount,meter_order_obj.allocated_amount)===-1"></i>
          </td>
          <td>
            {{formatMoney(meter_order_house_obj.money_3,4)}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span title="和用量计费对比">{{reNumber(meter_order_house_obj.money_3-meter_order_obj.allocated_amount)}}</span>
            <i class="el-icon-top" style="color: #ff0000" v-if="unusualChange(meter_order_house_obj.money_3,meter_order_obj.allocated_amount)===1"></i>
            <i class="el-icon-bottom" style="color: #ff6200" v-if="unusualChange(meter_order_house_obj.money_3,meter_order_obj.allocated_amount)===-1"></i>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span title="和分摊计费对比">{{reNumber(meter_order_house_obj.money_3-meter_order_object_obj.allocated_amount)}}</span>
            <i class="el-icon-top" style="color: #ff0000" v-if="unusualChange(meter_order_house_obj.money_3,meter_order_object_obj.allocated_amount)===1"></i>
            <i class="el-icon-bottom" style="color: #ff6200" v-if="unusualChange(meter_order_house_obj.money_3,meter_order_object_obj.allocated_amount)===-1"></i>
          </td>
        </tr>
        <tr>
          <td>总计收费</td>
          <td>{{formatMoney(meter_order_obj.all_amount,4)}}</td>
          <td>
            {{formatMoney(meter_order_object_obj.all_amount,4)}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span title="和用量计费对比">{{reNumber(meter_order_object_obj.all_amount-meter_order_obj.all_amount)}}</span>
            <i class="el-icon-top" style="color: #ff0000" v-if="unusualChange(meter_order_object_obj.all_amount,meter_order_obj.all_amount)===1"></i>
            <i class="el-icon-bottom" style="color: #ff6200" v-if="unusualChange(meter_order_object_obj.all_amount,meter_order_obj.all_amount)===-1"></i>
          </td>
          <td>
            {{formatMoney(meter_order_house_obj.all_money,4)}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span title="和用量计费对比">{{reNumber(meter_order_house_obj.all_money-meter_order_obj.all_amount)}}</span>
            <i class="el-icon-top" style="color: #ff0000" v-if="unusualChange(meter_order_house_obj.all_money,meter_order_obj.all_amount)===1"></i>
            <i class="el-icon-bottom" style="color: #ff6200" v-if="unusualChange(meter_order_house_obj.all_money,meter_order_obj.all_amount)===-1"></i>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span title="和分摊计费对比">{{reNumber(meter_order_house_obj.all_money-meter_order_object_obj.all_amount)}}</span>
            <i class="el-icon-top" style="color: #ff0000" v-if="unusualChange(meter_order_house_obj.all_money,meter_order_object_obj.all_amount)===1"></i>
            <i class="el-icon-bottom" style="color: #ff6200" v-if="unusualChange(meter_order_house_obj.all_money,meter_order_object_obj.all_amount)===-1"></i>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <h3>固定金额组成</h3>
    <div class="meter-order-table-wrap">
      <table class="meter-order-table" cellspacing="0" cellpadding="0" border="0" width="100%">
        <thead>
        <tr>
          <th style="width: 150px">固定金额类型</th>
          <th>三级表</th>
          <th>四级表</th>
          <th>合计</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>上下级扣减前</td>
          <td>{{formatMoney(meter_order_obj.step_one_amount3,4)}}</td>
          <td>{{formatMoney(meter_order_obj.step_two_amount3,4)}}</td>
          <td>{{formatMoney(meter_order_obj.fixed_amount3,4)}}</td>
        </tr>
        <tr>
          <td>上下级扣减后</td>
          <td>{{formatMoney(meter_order_obj.step_one_amount4,4)}}</td>
          <td>{{formatMoney(meter_order_obj.step_two_amount4,4)}}</td>
          <td>{{formatMoney(meter_order_obj.fixed_amount4,4)}}</td>
        </tr>
        <tr>
          <td>额外费用</td>
          <td>{{formatMoney(meter_order_obj.other_amount3,4)}}</td>
          <td>{{formatMoney(meter_order_obj.other_amount4,4)}}</td>
          <td>{{formatMoney(meter_order_obj.other_amount,4)}}</td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import {Loading} from "element-ui";
import MeterHttp from "../../../common/MeterHttp";
import moment from "moment";

export default {
  name: "MeterOrderUnusualChangeAll",
  components: {},
  provide() {
    return {
      where: this.where,
    }
  },
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return{
      activeName: 1,
      where:{
        number:"",
        name:"",
        apportion_meter_types:[1,2],
        meter_type:"",
        house_id:"",
        house_name:"",
        customer_id:"",
        customer_name:"",
        should_charge_date:"",
        energy:"",
        is_lock:"",
        is_examine:"",
      },
      where2:{
        charging_standard:'',
        chargeItem_name_id:''
      },
      apportion_meter_type_list:[{name:"存用量",val:1},{name:"线损",val:2}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
      energy_obj:{1:"业主能耗",2:"物业能耗",3:"分摊能耗"},
      meter_type_list: [],
      house_charge_list:[],
      house_charge_item_list:[],
      chargeItem_name_ids:null,
      loading: false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 50,
        page: 1
      },
      multipleSelection: [],
      meter_order_obj:{
        allocated_amount:0,
        amount3:0,
        amount4:0,
        total_dosage_number:0,
        total_sales_amount:0,
        allocated_amount4:0,
        xs_accumulate_amount:0,
        xs_accumulate_amount4:0,
        all_amount:0,
        fixed_amount3:0,
        fixed_amount4:0,
        other_amount:0,
        step_one_amount:0,
        step_one_amount3:0,
        step_one_amount4:0,
        step_two_amount:0,
        step_two_amount3:0,
        step_two_amount4:0,
        other_amount3:0,
        other_amount4:0
      },
      meter_order_object_obj:{
        allocated_amount:0,
        total_dosage_number:0,
        total_sales_amount:0,
        all_amount:0,
      },
      meter_order_house_obj:{
        all_money:0,
        money_1:0,
        money_2:0,
        money_3:0,
        all_count:0,
        count_1:0,
        count_2:0,
        count_3:0,
      },
      progress: 0,
      socket_key:null,
    }
  },
  mounted() {
    this.getMeterTypeList();
    this.mainObj.project_id&&this.getHouseChargeitemNameList();
    this.mainObj.project_id&&this.getHouseChargeList();
    this.where.should_charge_date=moment(this.mainObj.read_month).endOf('month').format("YYYY-MM-DD");
    this.pageChange(1)
  },
  methods:{
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_ids,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      });
    },
    pageChange(i){
      this.pageData.page = i
      this.getList()
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;
      MeterHttp.post("MeterOrder/getDataStatistics",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        batch_number:that.$route.query.batch_number,
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      },res=>{
        if (res.code) {
          that.meter_order_obj=res.data;
        }
      });
      MeterHttp.post("MeterOrderObject/getDataStatistics",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        batch_number:that.$route.query.batch_number,
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      },res=>{
        if(res.code){
          that.meter_order_object_obj=res.data;
        }
      });
      MeterHttp.post("MeterOrderHouse/getDataStatistics",{
        project_id:that.mainObj.project_id,
        ...where,
        ...that.where2,
        user_type:(that.$route.query.type||0),
        batch_number:that.$route.query.batch_number,
      }, res => {
        if (res.code) {
          that.meter_order_house_obj=res.data;
        }
      });
    },
    querySearchAsyncRoom(queryString, cb){
      if(!queryString){
        cb([]);
      }else {
        ERP.postRequest({
          url:"admin/Customer/getHouseList",
          data:{keyWord:queryString}
        },ret=>{
          if(ret.code) {
            cb(ret.data)
          }
        })
      }
    },
    handleSelect(item) {
      // this.where.house_id=item.id||0;
      this.where.house_name=item.value;
      this.pageChange(1);
    },
    querySearchAsync(queryString, cb) {
      const that = this;
      if(!queryString){
        cb([])
        return false
      }
      let from_data={}
      from_data.key_name=queryString;
      ERP.getRequest({url:"admin/Customer/getCustomerList",data:from_data},res=>{
        if (res.code) {
          cb(res.data.map(ret=>{return {
            value:`${ret.name}-【${(ret.house_list.map(re=>re.address).join(','))}】`,//
            id:ret.id,
            data:ret
          }}));
        }
      })
    },
    handleSelect2(item) {
      const that = this;
      // that.where.customer_id=item.data.id||0;
      that.where.customer_name=item.data.name;
      that.pageChange(1);
    },
    getAllExcel(){
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.house_name=that.mainObj.house_name;

      where.apportion_meter_types=where.apportion_meter_types.join(',');
      MeterHttp.post("MeterOrderHouse/getMeterOrderHouseExcel",{
        project_id:that.mainObj.project_id,
        ...where,
        ...that.where2,
        user_type:(that.$route.query.type||0),
      }, res => {
        if (res.code) {
          window.open(res.data)
          // that.initTaskClient(res.data,()=>{
          //
          // })
        }
        that.loading = false;
      })
    },
    getHouseChargeList(){
      const that = this;
      let where={};
      this.mainObj.project_id&&(where.pindex_id=this.mainObj.project_id);
      this.where2.chargeItem_name_id&&(where.chargeItem_name_ids=(this.where2.chargeItem_name_id+''));
      ERP.getRequest({
        url:"admin/HouseCharge/getList",
        data:{
          project_id:that.mainObj.project_id,
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      });
    },
    getHouseChargeitemNameList(){
      const that = this;
      let where={};
      this.mainObj.project_id&&(where.pindex_id=this.mainObj.project_id);
      ERP.getRequest({
        url:"admin/HouseChargeitemName/getHouseChargeitemNameList",
        data:{
          project_id:that.mainObj.project_id,
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_item_list=ret.data;
        }
      });
    },
    reNumber(x){
      return Math.floor(x*100)/100
    },
    unusualChange(a_val,b_val,rate=10){
      if(Math.abs(a_val-b_val)<=rate){
        return 0
      }
      if(a_val>b_val){
        return 1
      }else {
        return -1
      }
    }
  },
  computed:{
    all_money(){
      let m_arr=this.pageData.list.map(ret=>ret.charge_sum*1)
      return m_arr.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    },
    user_order_ids(){
      return this.multipleSelection.map(ret=>ret.id)
    },
    user_type(){
      return this.$route.query.type||0
    },
  },
  watch:{
    "mainObj.house_name":function (n,o) {
      if(n){
        this.pageChange(1)
      }
    },
    "mainObj.project_id":function (n,o) {
      if(n){
        this.getHouseChargeitemNameList();
      }
    },
    "mainObj.read_month":function (n,o) {
      if(n){
        //设置抄表月的最后一天为应收日期
        this.where.should_charge_date=moment(n).endOf('month').format('YYYY-MM-DD');
      }else {
        this.where.should_charge_date = '';
      }
    },
    'where2.chargeItem_name_id': {
      handler(val, oldVal) {
        this.where2.charging_standard="";
        this.getHouseChargeList();
      },
      deep: true
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../common.scss";
.header-tip{
  margin: 5px 0;
  padding: 5px 10px;
  background-color: #f56c6c;
  color: #FFFFFF;
  border-radius: 4px;
  display: inline-block;
}
.meter-order-table-wrap{
  margin-top: 20px;
}
.meter-order-table{
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
  text-align: center;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  margin-bottom: 10px;
}
.meter-order-table th{
  background-color: #f5f7fa;
  font-weight: 500;
  padding: 10px;
  border: 1px solid #dcdfe6;
  text-align: center;
}
.meter-order-table td{
  padding: 10px;
  border: 1px solid #dcdfe6;
  text-align: center;
}
//.meter-order-table td:first-child{
//  text-align: left;
//}
//.meter-order-table td:last-child{
//  text-align: right;
//}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/components/MeterOrderUnusualChangeAll.vue